import React, { Component } from 'react';
import '../styles/onboarding.css';

class OnboardingErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[OnboardingErrorBoundary]', error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false });
  };

  handleGoHome = () => {
    window.location.href = '/onboarding';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="hg-error-boundary"
        >
          <h1 className="hg-error-boundary__title">
            Oops — something went wrong
          </h1>
          <p className="hg-error-boundary__body">
            We hit an unexpected snag. You can try again or head back to the start.
          </p>
          <div className="hg-error-boundary__actions">
            <button
              onClick={this.handleRetry}
              className="hg-error-boundary__button hg-error-boundary__button--primary"
            >
              Try again
            </button>
            <button
              onClick={this.handleGoHome}
              className="hg-error-boundary__button hg-error-boundary__button--secondary"
            >
              Back to start
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default OnboardingErrorBoundary;
